export default __webpack_public_path__ + "static/media/bg-contact-2.cda3a3e6.jpg";